import { render } from "./ReferenceTableComponent.vue?vue&type=template&id=42e3e180"
import script from "./ReferenceTableComponent.vue?vue&type=script&lang=js"
export * from "./ReferenceTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__